import { array, option } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { CheckInConfigurationValue } from '@mews-commander/data-access';
import { Selected } from '@optimus-web/core';
import { values } from '@mews/fp';
import { TextKey } from '@mews-commander/enums';

export const isCheckInConfigurationValue = (value: Selected): value is CheckInConfigurationValue =>
    pipe(
        CheckInConfigurationValue,
        values,
        array.findFirst((enumValue) => enumValue === value),
        option.isSome
    );

export const getCheckInSameValues = (value: CheckInConfigurationValue) => ({
    reservationOwner: value,
    reservationAdult: value,
    reservationChild: value,
});

export const configurationValueOptionsData = [
    {
        value: CheckInConfigurationValue.Default,
        textKey: TextKey.ConfigurationFieldOptionDefault,
    },
    {
        value: CheckInConfigurationValue.Required,
        textKey: TextKey.ConfigurationFieldOptionRequired,
    },
    {
        value: CheckInConfigurationValue.Optional,
        textKey: TextKey.ConfigurationFieldOptionOptional,
    },
    {
        value: CheckInConfigurationValue.DoNotShow,
        textKey: TextKey.ConfigurationFieldOptionDoNotShow,
    },
];

export const getConfigurationValueTextKey = (value: CheckInConfigurationValue) =>
    pipe(
        configurationValueOptionsData,
        array.findFirst((opt) => opt.value === value),
        option.map((opt) => opt.textKey),
        option.getOrElse(() => TextKey.ConfigurationFieldOptionDefault)
    );
